import React from "react";
import { useSharedListIds } from "../../hooks/queries/useSharedListIds";
import { DEFAULT_LIST_EMOJI } from "../../constants/defaults";
import SharedListMark from "../ui/SharedListMark";

interface TaskListEmojiProps {
  listId: string | null;
  emoji?: string;
}

/**
 * The list emoji shown next to a task's title in priority view — the one
 * place a task card names its List today. Adds the shared mark (#286) when
 * that List has any list_members row. Split out of TaskCard.tsx, which is
 * pinned at its grandfathered file-size ceiling, so the sharing lookup
 * doesn't have to live there.
 */
const TaskListEmoji: React.FC<TaskListEmojiProps> = ({ listId, emoji }) => {
  const { data: sharedListIds } = useSharedListIds();
  const isShared = !!listId && !!sharedListIds?.has(listId);

  return (
    <span className="mr-1.5 inline-flex items-center gap-1">
      {emoji || DEFAULT_LIST_EMOJI}
      {isShared && <SharedListMark size={10} />}
    </span>
  );
};

export default TaskListEmoji;
